<template>
  <div id="payments">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <el-tooltip effect="dark" :content="$t('buttonGeneral.searchFilter')" placement="top">
              <el-button circle icon="fas fa-search" :type="isFiltered ? 'success' : ''" size="small" @click="isFilterEnabled = !isFilterEnabled"></el-button>
            </el-tooltip>
          </li>
        </ul>
        <!-- <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <a href="javascript:;" class="navbar-nav-link" @click="isFilterEnabled = !isFilterEnabled">
              {{ $t("event.components.participants.navbar.filterRecord") }}
              <i
                class="fas fa-search ml-1"
                :class="
                  ($store.state.payments.filter.searchTerm != null && $store.state.payments.filter.searchTerm != '') ||
                  $store.state.payments.filter.packetIDs.length != 0 ||
                  ($store.state.payments.filter.paymentStatus != null && $store.state.payments.filter.paymentStatus != '') ||
                  ($store.state.payments.filter.couponCode != null && $store.state.payments.filter.couponCode != '') ||
                  ($store.state.payments.filter.paymentType != null && $store.state.payments.filter.paymentType != '') ||
                  ($store.state.payments.filter.paymentID != null && $store.state.payments.filter.paymentID != '')
                    ? 'animate__animated animate__pulse animate__infinite text-info'
                    : ''
                "
              ></i>
            </a>
          </li>
        </ul> -->
      </portal>
      <div class="content animated fadeIn">
        <transition name="slide-fade">
          <div v-if="isFilterEnabled" class="card card-collapsed filter-card">
            <div class="card-header">
              <div class="card-title-container">
                <h5 class="card-title">{{ $t("event.filter.title") }}</h5>
                <span>{{ $t("event.filter.filterMsg") }}</span>
              </div>
              <div class="header-elements">
                <el-button-group>
                  <el-button @click="resetFilter" icon="el-icon-refresh-right" size="mini" round>{{ $t("event.buttons.reset") }}</el-button>
                  <el-button type="warning" icon="el-icon-close" size="mini" @click="isFilterEnabled = false" round></el-button>
                </el-button-group>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="form-group col-md-4">
                  <label style="display: block">{{ $t("event.filter.search") }}</label>
                  <el-input clearable v-model="$store.state.payments.filter.searchTerm" :placeholder="$t('event.textbox.searchPID')"></el-input>
                </div>

                <div class="form-group col-md-4">
                  <label style="display: block">{{ $t("event.filter.couponCode") }}</label>
                  <el-input clearable v-model="$store.state.payments.filter.couponCode" :placeholder="$t('event.textbox.searchCC')"></el-input>
                </div>
                <!-- 
                <div class="form-group col-md-4">
                  <label style="display: block">{{ $t("event.table.package") }}</label>
                  <el-select clearable multiple v-model="$store.state.payments.filter.packetIDs" :placeholder="$t('event.textbox.selectPack')" @clear="$store.state.payments.filter.packetIDs = []">
                    <el-option v-for="item in $store.state.packets.items" :key="item.id" :label="item.title" :value="item.id"></el-option>
                  </el-select>
                </div> -->

                <div class="form-group col-md-4">
                  <label style="display: block">{{ $t("event.filter.paymentID") }}</label>
                  <el-input clearable v-model="$store.state.payments.filter.paymentID" @clear="$store.state.payments.filter.paymentID = null" placeholder="..."></el-input>
                </div>

                <div class="form-group col-md-4">
                  <label style="display: block">{{ $t("event.filter.paymentType") }}</label>
                  <el-select clearable v-model="$store.state.payments.filter.paymentType" :placeholder="$t('event.textbox.payType')" @clear="$store.state.payments.filter.paymentType = null">
                    <el-option v-for="item in $enums.paymentType" :key="item.value" :label="item.title" :value="item.value"></el-option>
                  </el-select>
                </div>

                <div class="form-group col-md-4">
                  <label style="display: block">{{ $t("event.filter.paymentStatus") }}</label>
                  <el-select clearable v-model="$store.state.payments.filter.paymentStatus" :placeholder="$t('event.textbox.payStat')" @clear="$store.state.payments.filter.paymentStatus = null">
                    <el-option v-for="item in $enums.paymentStatus" :key="item.value" :label="item.title" :value="item.value"></el-option>
                  </el-select>
                </div>
                <div class="form-group col-md-4">
                  <label>{{ this.$t("event.filter.tag") }}</label>

                  <el-select multiple v-model="$store.state.payments.filter.tagIDs" :placeholder="$t('event.textbox.selectTag')">
                    <el-option v-for="item in $store.state.tags.items" :key="item.id" :label="item.title" :value="item.id">
                      <template>
                        <i class="fas fa-circle mr-2" :style="'color:' + item.color"></i>
                        <span>{{ item.title }}</span>
                      </template>
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ $t("event.menu.salesconfirmations.title") }}</h5>
              <span v-if="$store.state.payments.items.length > 0" v-html="$t('totalContent', [$store.state.payments.filter.total])"></span>
            </div>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe('https://holacon.com/product-guide/detail/sales-confirmation--how-to-manage-your-event-sales')" icon="fas fa-life-ring" size="mini" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="loading == 'loadingList' ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="refresh" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>
          <div class="card-body" v-if="$store.state.payments.items.length > 0">
            <div class="payments-box-container">
              <div class="custom-grid-table-header payment-list-header">
                <span>{{ $t("registrationManagement.salesConfirmations.participant") }}</span>
                <span>{{ $t("registrationManagement.salesConfirmations.paymentInformation") }}</span>
                <span>{{ $t("registrationManagement.salesConfirmations.amount") }}</span>
                <span>{{ $t("registrationManagement.salesConfirmations.status") }}</span>
              </div>
              <div class="payment-list-container">
                <div class="item" v-for="item in $store.state.payments.items" :key="item.id">
                  <span class="participant-detail d-flex align-items-center justify-content-center"> <ParticipantMini :type="1" :data="prepareParticipantMini(item)" @click.native="openParticipantDetail(item.id)"/></span>
                  <div class="payment-infos-list">
                    <div class="item" v-for="payment in item.paymentInfos" :key="payment.id">
                      <div class="payment-info">
                        <div class="text-1">{{ $t("registrationManagement.salesConfirmations.paymentIdDateSource") }}</div>
                        <div
                          class="text-3 cursor-pointer"
                          @click="
                            $store.state.payments.filter.paymentID = payment.paymentID;
                            isFilterEnabled = true;
                          "
                        >
                          #{{ payment.paymentID }} [{{ getEnumsDisplay("PaymentType", payment.paymentType) }}]
                        </div>
                        <div class="text-2">{{ $moment(payment.createDate).format("DD MMMM YYYY, dddd HH:mm") }}</div>
                        <div class="text-3" v-if="item.registrationForm != null">{{ item.registrationForm.title }}</div>
                      </div>
                      <div class="payment-info">
                        <div class="text-1">{{ $t("registrationManagement.salesConfirmations.amountCodePackage") }}</div>
                        <div class="text-2" v-if="payment.paidPrice != null && payment.paidPrice > 0">{{ payment.paidPrice.toFixed(2) }} {{ getEnumsDisplay("Currency", payment.currency) }}</div>
                        <div class="text-2" v-else>{{ $t("registrationManagement.salesConfirmations.free") }}</div>
                        <div
                          class="text-3 cursor-pointer"
                          @click="
                            $store.state.payments.filter.couponCode = payment.couponCode;
                            isFilterEnabled = true;
                          "
                          v-if="payment.couponCode != null"
                        >
                          {{ payment.couponCode }}
                        </div>
                        <div class="text-3" v-if="item.packet != null">{{ item.packet.title }}</div>
                      </div>
                      <div>
                        <template v-if="payment.paymentStatus != 2">
                          <el-dropdown placement="bottom-start">
                            <span class="status payment-awaiting" :class="{ 'payment-awaiting': payment.paymentStatus == 0, rejected: payment.paymentStatus == 2, confirmed: payment.paymentStatus == 1 }">
                              <template v-if="payment.paymentStatus == 0 && payment.paymentType != 3">
                                <i class="fas fa-clock"></i>

                                {{ $t("summaryComponent.waiting-for-approval") }}
                              </template>
                              <template v-if="payment.paymentStatus == 0 && payment.paymentType == 3">
                                <i class="fas fa-clock"></i>

                                {{ $t("summaryComponent.payment-pending") }}
                              </template>
                              <template v-if="payment.paymentStatus == 1">
                                <i class="fas fa-check-circle"></i>

                                {{ $t("summaryComponent.approved") }}
                              </template>
                              <!-- <template v-if="payment.paymentStatus == 2">
                                <i class="fas fa-times-circle"></i>

                                {{ $t("summaryComponent.denied") }}
                              </template> -->
                            </span>
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item class="status-pending-approve" v-if="payment.paymentStatus != 1" @click.native="changePaymentStatus(payment.paymentID, 1)">
                                <i class="fas fa-check"></i>
                                {{ $t("registrationManagement.salesConfirmations.confirm") }}
                              </el-dropdown-item>
                              <el-dropdown-item class="status-pending-reject" v-if="payment.paymentStatus != 2" @click.native="changePaymentStatus(payment.paymentID, 2)">
                                <i class="fas fa-times"></i>
                                {{ $t("registrationManagement.salesConfirmations.reject") }}
                              </el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>
                        </template>
                        <span v-else class="status payment-awaiting" :class="{ 'payment-awaiting': payment.paymentStatus == 0, rejected: payment.paymentStatus == 2, confirmed: payment.paymentStatus == 1 }">
                          <i class="fas fa-times-circle"></i>

                          {{ $t("summaryComponent.denied") }}
                        </span>
                      </div>
                      <el-tooltip effect="dark" :content="$t('buttonGeneral.show')" placement="top">
                        <span class="d-flex justify-content-center"><el-button size="mini" circle type="primary" icon="fas fa-search" @click="openPayment(item, payment)"></el-button></span>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <HolaconLottieNoData class="w-100" key="create-loading" :source="'holacon-sales-confirmation-lottie'" :title="$t('event.menu.salesconfirmations.title')" @btnAdd="false" @btnRefresh="refresh" :buttonAdd="false" :buttonRefresh="true" :loading="loading" />
          </div>
          <div class="card-footer"></div>
          <el-pagination background @size-change="handleSizeChange" v-if="$store.state.payments.items.length > 0" @current-change="handleCurrentChange" :current-page.sync="$store.state.payments.filter.page" :page-sizes="[20, 30, 40, 50]" :page-size="100" layout="total, sizes, prev, pager, next, jumper" :total="$store.state.payments.filter.total"></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" append-to-body destroy-on-close class="large" :visible.sync="detailDialog" :title="$t('message.payDetails')">
      <SummaryComponent :participant="paymentItem" @closeDialog="detailDialog = false" :paymentInfo="paymentInfoItem" v-if="detailDialog" :key="detailDialog" />
    </el-dialog>
    <!-- <el-dialog:visible.sync="detailDialog" width="80%">
      <PaymentDetail :key="detailDialog" @closeExcelDialog="detailDialog = false" :data="detailData" :participant="participantData" />
    </el-dialog> -->
  </div>
</template>

<script>
import SummaryComponent from "../../components/participants/SummaryComponent.vue";
import SpeakerAddUpdate from "../../components/SpeakerAddUpdate";
import PaymentDetail from "../../components/PaymentDetail";
import axios from "axios";
import PageCountInfo from "../../components/PageCountInfo";
import ParticipantMini from "../../components/ParticipantMini";
import $ from "jquery";
export default {
 metaInfo() {
    return {
      title: this.$t("eventPageTitle.paymentsAndConfirmation"),
    };
  },
  components: {
    SpeakerAddUpdate,
    PaymentDetail,
    PageCountInfo,
    ParticipantMini,
    SummaryComponent
  },
  name: "Speakers",
  data() {
    return {
      paymentItem: null,
      paymentInfoItem: null,
      modalVisible: false,
      loading: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "speaker",
      widgetUrl: "https://cdn.holacon.com/widgets/event-speakers.html?applicationID=5e2b3b73286bd618b47d1e6e&amp;eventID=5e30227b83089521b86ef7bf",
      excelTemplateUrl: this.$excelTemplateUrl + "sample/SpeakerExcel/SpeakerImportSample.xlsx",
      detailData: null,
      detailDialog: false,
      participantData: null
    };
  },
  methods: {
    resetFilter() {
      this.$store.state.payments.filter.searchTerm = null;
      this.$store.state.payments.filter.packetIDs = [];
      this.$store.state.payments.filter.tagIDs = [];
      this.$store.state.payments.filter.paymentType = null;
      this.$store.state.payments.filter.paymentStatus = null;
      this.$store.state.payments.filter.couponCode = null;
      this.$store.state.payments.filter.paymentID = null;
    },
    async refresh() {
      this.loading = "loadingList";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("getPayments");
        this.loading = false;
      }, 500);
    },
    openPayment(item, payment) {
      this.paymentItem = item;
      this.paymentInfoItem = payment;
      this.detailDialog = !this.detailDialog;
    },
    async changePaymentStatus(id, status) {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var payload = {
          paymentID: id,
          status: status,
          cancellationReason: null
        };
        if (status != 2) {
          var res = await this.$store.dispatch("changeParticipantStatus", payload);
          if (!res.data.alert.hasError) {
            await this.$store.dispatch("getPayments");
          }
        } else {
          if (this.$i18n.locale == "tr") {
            var reason = await this.$prompt("Lütfen bir sebep belirtin.", "Uyarı", {
              confirmButtonText: "Tamam",
              cancelButtonText: "Vazgeç",
              inputPattern: /(.|\s)*\S(.|\s)*/,
              inputErrorMessage: "Lütfen boş bırakmayınız."
            })
              .then(async ({ value }) => {
                payload.cancellationReason = value;
                var res = await this.$store.dispatch("changeParticipantStatus", payload);
                if (!res.data.alert.hasError) {
                  await this.$store.dispatch("getPayments");
                }
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "İşlem iptal edildi."
                });
              });
          } else {
            var reason = await this.$prompt("Please provide a reason.", "Warning", {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              inputPattern: /(.|\s)*\S(.|\s)*/,
              inputErrorMessage: "Please fill in all fields."
            })
              .then(async ({ value }) => {
                payload.cancellationReason = value;
                var res = await this.$store.dispatch("changeParticipantStatus", payload);
                if (!res.data.alert.hasError) {
                  await this.$store.dispatch("getPayments");
                }
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "The process has been cancelled."
                });
              });
          }
        }
      }, 500);
    },
    // changePaymentStatus(payload) {
    //   this.$store.dispatch("changePaymentStatus", {
    //     ...payload,
    //     context: this,
    //   })
    // },
    prepareParticipantMini(row) {
      return {
        firstName: row.firstName,
        lastName: row.lastName,
        tagID: row.tagID,
        id: row.id
      };
    },
    exportExcel() {
      this.$confirm(this.$t("message.export"), this.$t("message.warn"), {
        confirmButtonText: this.$t("event.variables.yes"),
        cancelButtonText: this.$t("event.variables.no"),
        type: "warning"
      }).then(() => {
        axios.post("speaker/export", { id: null }).then(res => {
          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
          }
        });
      });
    },
    excelProgress(event) {
      this.excelPercent = event.percent;
    },
    itemUpdated(item) {
      var index = this.$store.state.payments.items.findIndex(k => k.id == item.id);
      if (index != -1) {
        this.$store.state.payments.items.splice(index, 1, item);
      }
    },
    itemAdded(item) {
      this.$store.dispatch("getPayments");
    },
    handleSizeChange(take) {
      this.$store.commit("setPaymentTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setPaymentPage", page);
    },
    deleteItem(index) {
      this.$store.dispatch("deletePayment", { index, context: this });
    },
    statusChanged(value, index) {
      this.$store.dispatch("togglePayment", { index, value });
    },
    handleSelectionChange(items) {
      this.$store.commit("setSelectedPayments", items);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    }
  },
  mounted() {
    this.resetFilter();
    this.$store.dispatch("getPayments");

    if (this.$store.state.payments.filter.couponCode != null) {
      this.isFilterEnabled = true;
    }
  },
  created() {},
  computed: {
    skip() {
      return (this.$store.state.payments.filter.page - 1) * this.$store.state.payments.filter.take;
    },
    take() {
      return this.skip + this.$store.state.payments.items.length;
    },
    isFiltered() {
      if (
        (this.$store.state.payments.filter.searchTerm != null && this.$store.state.payments.filter.searchTerm != "") ||
        (this.$store.state.payments.filter.packetIDs != null && this.$store.state.payments.filter.packetIDs != "") ||
        (this.$store.state.payments.filter.paymentType != null && this.$store.state.payments.filter.paymentType != "") ||
        (this.$store.state.payments.filter.paymentStatus != null && this.$store.state.payments.filter.paymentStatus != "") ||
        (this.$store.state.payments.filter.couponCode != null && this.$store.state.payments.filter.couponCode != "") ||
        (this.$store.state.payments.filter.paymentID != null && this.$store.state.payments.filter.paymentID != "") ||
        (this.$store.state.payments.filter.tagIDs != null && this.$store.state.payments.filter.tagIDs != "")
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    "$store.state.payments.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getPayments");
      }, 500);
    },
    "$store.state.payments.filter.paymentType": function(val) {
      this.$store.dispatch("getPayments");
    },
    "$store.state.payments.filter.paymentID": function(val) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getPayments");
      }, 500);
    },
    "$store.state.payments.filter.paymentStatus": function(val) {
      this.$store.dispatch("getPayments");
    },
    "$store.state.payments.filter.packetIDs": function(val) {
      this.$store.dispatch("getPayments");
    },
      "$store.state.payments.filter.tagIDs": function(val) {
      this.$store.dispatch("getPayments");
    },
    "$store.state.payments.filter.couponCode": function(val) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getPayments");
      }, 500);
    }
  }
};
</script>
0
<style lang="less" scoped>
.payments-box-container {
  .payment-list-header {
    grid-template-columns: 180px 1fr 1fr 170px 90px !important;
  }
  .payment-list-container {
    display: flex;
    flex-direction: column;
    & > .item {
      .participant-detail {
        padding: 10px;
        height: max-content;
        .participant-card-mini.mini {
          align-items: center;
        }
      }
      display: grid;
      grid-template-columns: 180px 1fr;
      border-radius: 8px;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: unset;
      }
      background-color: #f1f1f1;
      gap: 0.5rem;
      & > .payment-infos-list {
        height: 100%;
        display: flex;
        flex-direction: column;
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: unset;
        }
        background-color: #f1f1f1;
        gap: 0.5rem;
        & > .item {
          display: flex;
          flex-direction: row;
          border-left: 2px solid white;
          & > .item {
            & > .payment-info {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              .text-1 {
                font-weight: 500;
              }
              .text-2 {
                font-weight: bold;
              }
              .text-3 {
                text-decoration: underline;
                font-weight: bold;
                color: #03658c;
              }
            }
            .text-2 {
              font-weight: bold;
            }
            .text-3 {
              text-decoration: underline;
              font-weight: bold;
              color: #03658c;
            }
          }
          display: grid;
          grid-template-columns: 1fr 1fr 170px 90px;
          padding: 10px;
          gap: 0.5rem;
          align-items: center;
          border-radius: 8px;
          border-bottom: 2px solid white;

          &:last-child {
            border: unset;
          }
        }
        gap: 0.5rem;
      }
    }
  }
}
</style>
<style lang="less">
.payment-list-container {
  & > .item {
    border-radius: 8px;
    overflow: hidden;
  }
  span {
    font-weight: 500;
    font-size: 13px;
    color: #505763;
    b {
      color: #292f3b;
      font-weight: 600;
      cursor: pointer;
    }
    strong {
      font-weight: 600;
      color: #03658c;
      cursor: pointer;
    }
    &.status {
      display: block;
      width: fit-content;
      padding: 8px 10px;
      border-radius: 8px;
      color: #292f3b;
      font-weight: 500;
      i {
        margin-right: 8px;
      }
      &.pending {
        background: #f1f1f1;
        cursor: pointer;
        i {
          color: #292f3b;
        }
      }
      &.payment-awaiting {
        background: #fff2e5;
        cursor: pointer;
        i {
          color: #f98559;
        }
      }
      &.confirmed {
        background: #e5fff8;
        i {
          color: #50bfbf;
        }
      }
      &.rejected {
        background: #fff2f2;
        i {
          color: #ff6565;
        }
      }
    }
  }
}
.participant-info {
  width: 200px;
  padding-left: 20px;
}
.payment {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex: 1;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.125);
}

.payment-item {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 10px 15px;
  background: whitesmoke;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.125);
  border-left: 0.5px solid rgba(0, 0, 0, 0.125);
}

.payment-item:last-child {
  border-bottom: 0px;
}

.payment:first-child {
  border-top: 0.5px solid rgba(0, 0, 0, 0.125);
}

.cols {
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: flex-start;
  position: relative;
}

.cols .col {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.col-value p {
  margin: 0;
  color: silver;
}

.col-value span {
  color: #333;
}

.cols .col .col-title {
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/pages/event/Payments.vue